import styled, { css } from 'styled-components';
import themeStyle from '../../../styles/themes/light';
import { ColorEvent } from './index';

type IColor = {
  [key in ColorEvent]: string;
};

type ContainerProps = {
  color: ColorEvent;
  left: number;
  zIndex: number;
  hasBlur: boolean;
};

const colorValues: IColor = {
  insideTimeLimit: themeStyle.colors.tertiary,
  todayOrLater: themeStyle.colors.error_200,
  demandProposal: themeStyle.colors.yellow,
  empty: themeStyle.colors.background,
};

export const Container = styled.div<ContainerProps>`
  overflow: hidden;
  position: absolute;
  min-width: 8rem;
  max-width: 8rem;
  max-height: 5rem;
  min-height: 4.5rem;
  box-shadow: 0px 3px 6px #00000029;
  padding: 0.5rem;
  background-color: ${({ color }) => colorValues[color]};
  .event-schedule {
    header {
      display: flex;
      align-items: center;
      img {
        width: 1.5rem;
      }
    }

    p {
      margin-top: 0.25rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* number of lines to show */
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    a,
    p {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.secondary};
      margin-top: 0.25rem;
    }
    a {
      font-weight: 500;
    }
  }

  left: ${({ left }) => left}px;
  transition: all linear 200ms;
  z-index: ${({ zIndex }) => zIndex};

  ${({ hasBlur }) =>
    hasBlur &&
    css`
      filter: blur(2px);
    `}

  ${({ hasBlur }) =>
    !hasBlur &&
    css`
      filter: none;
    `}

  &:hover {
    z-index: ${({ zIndex }) => zIndex + 1};
  }

  top: 0;
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary};
  }

  #divContainerEvents {
    display: flex;
    justify-content: space-between;
    .Title {
      font-weight: 450;
    }
    button {
      border: 0;
      margin: 0;
      background-color: transparent;
      transition: all ease-out 200ms;
      padding: 4px;
    }

    button:hover {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 50%;
    }

    img {
      width: 20px;
    }
  }
  .btn-view-solicitation {
    width: 100%;
    height: 25px;
    background-color: ${({ theme }) => theme.colors.background_white};
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.primary};
    font-family: 'Futura PT';
    font-weight: 450;
    margin-top: 8px;
    cursor: pointer;
    transition: all linear 200ms;
  }
  .btn-view-solicitation:hover {
    filter: brightness(0.9);
  }
`;

export const Title = styled.p`
  font-weight: 450;
`;

export const Description = styled.p`
  font-weight: 300;
  padding-top: 0.5rem;
`;

export const ContainerMakingNoteEvent = styled.td`
  width: 8rem;
  height: 88px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.background_white};
  top: 0;
  #ButtonAddAnotation {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    outline: 0;
    border: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: none;
  }
  #textMakingNote {
    display: flex;
    flex-direction: column !important;
    padding: 0.2rem;
    height: 100%;
    justify-content: center;
    align-items: center;
    outline: 0;
    resize: none;
    border: 0 !important;
  }

  button {
    width: 100%;
    color: ${({ theme }) => theme.colors.tertiary_500};
    text-decoration: underline;
    font-size: 0.7rem;
    border: none;
    display: flex;
  }

  .close-button {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 20%;
    button {
      width: 20%;
    }
    svg {
      width: 0.8rem;
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .makingNotesButtons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;
